












import { faSearch } from '@fortawesome/free-solid-svg-icons'
import BaseSearchHandler from '~/components/car/classifieds/search/facets/handlers/BaseSearchHandler.vue'
import { DEBOUNCE_SLOW } from '~/constants/debounce'
import { debounce } from '~/utils/function'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  extends: BaseSearchHandler,
  data() {
    return {
      q: null
    }
  },
  computed: {
    icons: () => ({
      search: faSearch
    }),
    placeholder() {
      return this.searchPlaceholder || this.$t('what are you searching?')
    }
  },
  methods: {
    async onBackendValues({ value, selected }) {
      let backQ = this.q
      if (selected.length && selected.length > 0) {
        backQ = selected[0].toString()
      } else {
        backQ = value
      }

      if (this.q === null || this.q === '' || backQ === null) {
        this.q = backQ
      } else if (this.q !== backQ) {
        await this.$nextTick()
        this.emitParams([
          {
            name: this.defaultUrlArgName,
            value: this.q
          }
        ])
      }
    },
    onClear() {
      this.emitParams([
        {
          name: this.defaultUrlArgName,
          value: null
        }
      ])
    },
    onInput: debounce(function(text: string) {
      this.emitParams([
        {
          name: this.defaultUrlArgName,
          value: text
        }
      ])
    }, DEBOUNCE_SLOW)
  }
})
